export type CalendarProvider = "google" | "outlook";

export const CALENDAR_PROVIDERS = {
	GOOGLE: "google",
	OUTLOOK: "outlook",
};
